module.exports = __webpack_public_path__ + "img/icon-points1.052879a5.png";